import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  stripePaymentVerifyV4,
  deletePaymentIntent,
} from "../../store/reducers/paymentReducer";
import { useNavigate, useParams } from "react-router";
import { CircularProgress } from "@mui/material";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import { addCurrentAccount } from "../../store/reducers/userProfileReducer";
import { getDigiSignerSigningURL } from "../../store/reducers/dashboardReducer";

const GetSigningURL = (props) => {
  const params = useParams();

  const [loading, setLoading] = useState("");

  const [ShowPopup, setShowPopup] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("params", params);
    setLoading(true);
    dispatch(getDigiSignerSigningURL())
      .then((res) => {
        console.log(res);
        window.location.href = res.url;
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [params]);

  return (
    <div className="challenge-payment-success">
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
      />
      {loading ? (
        <>
          <CircularProgress
            color="primary"
            determinate={false}
            sx={{ position: "absolute", left: "50%", top: "35%" }}
          />
          <h2 className="digiSigner-redirect-text">
            Redirecting to DigiSigner....
          </h2>
        </>
      ) : (
        false
      )}
    </div>
  );
};

export default GetSigningURL;
